import { css } from 'styled-components'
import { getTypographyStyles } from '../Typography'
import { CustomStyleOverrideProps } from './types'
import { getBorderColor, getBorderRadius, getBrandPrimaryColor, getTextPrimaryColor, getTextSecondaryColor } from './utils'

export const flatPickerStyles = (baseOverrides?: Partial<CustomStyleOverrideProps>) => css`
  .flatpickr-input {
    display: none !important;
  }

.flatpickr-calendar {
    opacity: 0;
    display: flex;
    flex-direction: column;
    position: relative;
    text-align: center;
    visibility: hidden;
    animation: none;
    direction: ltr;
    font-size: 14px;
    line-height: 24px;
    position: absolute;
    box-sizing: border-box;
    touch-action: manipulation;
    box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
    width: auto;
    background: white;
    margin-right: 0;
    border-radius: ${getBorderRadius(baseOverrides)};
    padding: 10px;
    border: 2px solid ${getBorderColor(baseOverrides)};
    font: var(--font-primary);
    top: 60px !important;
    left: 0;
    min-width: 330px;

    * {
      font: var(--font-primary);
    }

    &.open {
        opacity: 1;
        visibility: visible;
        top: 60px !important;
        left: 0;
    }

    &.inline {
        display: block;
        opacity: 1;
        visibility: visible;
        top: 0px !important;
        posiiton: relative;
        width: fit-content;

        box-shadow: none;
        background: none;
        border: none;

        &:after {
            display: none;
        }
    }

    &:after {
        content: '';
        position: absolute;
        top: -6px;
        left: 20px;
        display: block;
        background-color: var(--white);
        height: 9px;
        width: 9px;
        transform: rotate(45deg);
        border-left: solid 1px ${getBorderColor(baseOverrides)};
        border-top: solid 1px ${getBorderColor(baseOverrides)};
    }

    .flatpickr-months {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      gap: 10px;
      padding: 0;

      .flatpickr-next-month,
      .flatpickr-prev-month {
        cursor: pointer;
        padding: 10px;

        .icon {
          position: static;
          font-size: 20px;
          color: ${getTextPrimaryColor(baseOverrides)};
        }
      }

      .flatpickr-month {
        cursor: pointer;
        background: transparent;
        color: rgba(0, 0, 0, 0.9);
        fill: rgba(0, 0, 0, 0.9);
        padding: 0;
        line-height: 1;
        text-align: center;
        position: relative;
        user-select: none;
        overflow: hidden;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .flatpickr-current-month {
          font-size: 135%;
          line-height: inherit;
          font-weight: 300;
          color: inherit;
          position: static;
          width: auto;
          left: auto;
          padding: 6.16px 0 0 0;
          line-height: 1;
          height: auto;
          display: block;
          text-align: center;
          transform: none;
          padding: 0;
          color: ${getTextSecondaryColor(baseOverrides)};
        }
      }

      .flatpickr-monthDropdown-months {
        border: none;
        background-image: none !important;
        background: none !important;
        appearance: none;
        ${getTypographyStyles('h3')}
        color: ${getTextPrimaryColor(baseOverrides)};
      }
    }

    .flatpickr-innerContainer {
        padding: 0;
        display: block;
        display: flex;
        box-sizing: border-box;
        overflow: hidden;

        .flatpickr-rContainer {
        .flatpickr-weekdays {
            .flatpickr-weekdaycontainer {
            .flatpickr-weekday {
                color: ${getTextSecondaryColor(baseOverrides)};
            }
            }
        }

        .flatpickr-days {
            .dayContainer + .dayContainer {
                box-shadow: -1px 0 0 ${getBorderColor(baseOverrides)};
            }

            .dayContainer {
            padding: 0;
            outline: 0;
            text-align: left;
            width: 307.875px;
            min-width: 307.875px;
            max-width: 307.875px;
            box-sizing: border-box;
            display: inline-block;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            transform: translate3d(0px, 0px, 0px);
            opacity: 1;

            .flatpickr-day {
                border: 1px solid transparent;
                border-radius: 150px;
                box-sizing: border-box;
                color: ${getBorderColor(baseOverrides)};
                cursor: pointer;
                font-weight: 400;
                width: 14.2857143%;
                flex-basis: 14.2857143%;
                max-width: 39px;
                height: 39px;
                line-height: 39px;
                margin: 0;
                display: inline-block;
                position: relative;
                justify-content: center;
                text-align: center;
                color: ${getTextSecondaryColor(baseOverrides)};
                border-radius: var(--border-radius-sm);

                &.selected {
                border-color: ${getBrandPrimaryColor(baseOverrides)};
                font-weight: bold;
                background: ${getBrandPrimaryColor(baseOverrides)};
                color: white;

                &:hover {
                    border-color: ${getBrandPrimaryColor(baseOverrides)};
                    font-weight: bold;
                    background: ${getBrandPrimaryColor(baseOverrides)};
                    color: white;
                }
                }

                &:hover {
                    border-color: var(--gray200);
                    background: var(--gray200);
                    color: ${getBrandPrimaryColor(baseOverrides)};
                }

                &.today {
                    border-color: transparent;
                    font-weight: bold;
                    color: ${getBrandPrimaryColor(baseOverrides)};

                    &.selected {
                        color: white;

                        &:hover {
                        color: white;
                        }
                    }
                }

                &.inRange {
                border-radius: 0;
                }

                &.startRange {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                }

                &.endRange {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                }

                &.flatpickr-disabled {
                color: ${getBorderColor(baseOverrides)};

                &:hover {
                    color: ${getBorderColor(baseOverrides)};
                    background: none;
                    border-color: white;
                    cursor: not-allowed;
                }
                }
            }
            }
        }
        }
    }
  }

  .flatpickr-calendar.open {
    display: inline-block;
    z-index: 99999;
  }
  .flatpickr-calendar.animate.open {
    animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  }
  .flatpickr-calendar.inline {
    display: block;
    position: relative;
    top: 2px;
  }
  .flatpickr-calendar.static {
    position: absolute;
    top: calc(100% + 2px);
  }
  .flatpickr-calendar.static.open {
    z-index: 999;
    display: block;
  }
  .flatpickr-calendar.multiMonth
    .flatpickr-days
    .dayContainer:nth-child(n + 1)
    .flatpickr-day.inRange:nth-child(7n + 7) {
    box-shadow: none !important;
  }
  .flatpickr-calendar.multiMonth
    .flatpickr-days
    .dayContainer:nth-child(n + 2)
    .flatpickr-day.inRange:nth-child(7n + 1) {
    box-shadow: -2px 0 0 ${getBorderColor(baseOverrides)}, 5px 0 0 ${getBorderColor(baseOverrides)};
  }
  .flatpickr-calendar .hasWeeks .dayContainer,
  .flatpickr-calendar .hasTime .dayContainer {
    border-bottom: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .flatpickr-calendar .hasWeeks .dayContainer {
    border-left: 0;
  }
  .flatpickr-calendar.showTimeInput.hasTime .flatpickr-time {
    height: 40px;
    border-top: 1px solid ${getBorderColor(baseOverrides)};
  }
  .flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
    height: auto;
  }
  .flatpickr-calendar.rightMost:before,
  .flatpickr-calendar.rightMost:after {
    left: auto;
    right: 22px;
  }
  .flatpickr-calendar.arrowTop:before,
  .flatpickr-calendar.arrowTop:after {
    bottom: 100%;
  }
  .flatpickr-calendar.arrowTop:before {
    border-bottom-color: ${getBorderColor(baseOverrides)};
  }
  .flatpickr-calendar.arrowTop:after {
    border-bottom-color: #fff;
  }
  .flatpickr-calendar.arrowBottom:before,
  .flatpickr-calendar.arrowBottom:after {
    top: 100%;
  }
  .flatpickr-calendar.arrowBottom:before {
    border-top-color: ${getBorderColor(baseOverrides)};
  }
  .flatpickr-calendar.arrowBottom:after {
    border-top-color: #fff;
  }
  .flatpickr-calendar:focus {
    outline: 0;
  }
  .flatpickr-wrapper {
    position: relative;
    display: inline-block;
  }
  .flatpickr-months .flatpickr-prev-month i,
  .flatpickr-months .flatpickr-next-month i {
    position: relative;
  }
  .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
  .flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
    left: 0;
  }
  .flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
  .flatpickr-months .flatpickr-next-month.flatpickr-next-month {
    right: 0;
  }
  .flatpickr-months .flatpickr-prev-month:hover,
  .flatpickr-months .flatpickr-next-month:hover {
    color: #959ea9;
  }
  .flatpickr-months .flatpickr-prev-month svg,
  .flatpickr-months .flatpickr-next-month svg {
    fill: ${getTextPrimaryColor(baseOverrides)};
  }
  .flatpickr-months .flatpickr-prev-month:hover svg,
  .flatpickr-months .flatpickr-next-month:hover svg {
    fill: ${getBrandPrimaryColor(baseOverrides)};
  }
  .flatpickr-months .flatpickr-prev-month svg,
  .flatpickr-months .flatpickr-next-month svg {
    width: 14px;
    height: 14px;
  }
  .flatpickr-months .flatpickr-prev-month svg path,
  .flatpickr-months .flatpickr-next-month svg path {
    transition: fill 0.1s;
    fill: inherit;
  }
  .numInputWrapper {
    position: relative;
    height: auto;
    color: ${getTextSecondaryColor(baseOverrides)};
    background: none;

    &:hover {
        background: none;
    }
  }
  .numInputWrapper input,
  .numInputWrapper span {
    display: inline-block;
  }
  .numInputWrapper input {
    width: 100%;
  }
  .numInputWrapper input::-ms-clear {
    display: none;
  }
  .numInputWrapper span {
    position: absolute;
    right: 0;
    width: 14px;
    padding: 0 4px 0 2px;
    height: 50%;
    line-height: 50%;
    opacity: 0;
    cursor: pointer;
    border: 1px solid rgba(57, 57, 57, 0.15);
    box-sizing: border-box;
  }
  .numInputWrapper span:hover {
    background: none;
  }
  .numInputWrapper span:active {
    background: none;
  }
  .numInputWrapper span:after {
    display: block;
    content: '';
    position: absolute;
  }
  .numInputWrapper span.arrowUp {
    top: 0;
    border-bottom: 0;
  }
  .numInputWrapper span.arrowUp:after {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid rgba(57, 57, 57, 0.6);
    top: 26%;
  }
  .numInputWrapper span.arrowDown {
    top: 50%;
  }
  .numInputWrapper span.arrowDown:after {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid rgba(57, 57, 57, 0.6);
    top: 40%;
  }
  .numInputWrapper span svg {
    width: inherit;
    height: auto;
  }
  .numInputWrapper span svg path {
    fill: rgba(0, 0, 0, 0.5);
  }
  .numInputWrapper:hover span {
    opacity: 1;
  }
  .flatpickr-current-month span.cur-month {
    font-family: inherit;
    font-weight: 700;
    color: inherit;
    display: inline-block;
    margin-left: 0.5ch;
    padding: 0;
  }
  .flatpickr-current-month span.cur-month:hover {
    background: rgba(0, 0, 0, 0.05);
  }
  .flatpickr-current-month .numInputWrapper {
    width: 6ch;
    width: 7ch\0;
    display: inline-block;
  }
  .flatpickr-current-month .numInputWrapper span.arrowUp:after {
    border-bottom-color: rgba(0, 0, 0, 0.9);
  }
  .flatpickr-current-month .numInputWrapper span.arrowDown:after {
    border-top-color: rgba(0, 0, 0, 0.9);
  }
  .flatpickr-current-month input.cur-year {
    background: transparent;
    box-sizing: border-box;
    color: inherit;
    cursor: text;
    padding: 0 0 0 0.5ch;
    margin: 0;
    display: inline-block;
    height: auto;
    border: 0;
    border-radius: 0;
    vertical-align: initial;
    ${getTypographyStyles('h3')}
    color: ${getTextPrimaryColor(baseOverrides)};
  }
  .flatpickr-current-month input::-webkit-outer-spin-button,
  .flatpickr-current-month input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .flatpickr-current-month input.cur-year:focus {
    outline: 0;
  }
  .flatpickr-current-month input.cur-year[disabled],
  .flatpickr-current-month input.cur-year[disabled]:hover {
    font-size: 100%;
    color: ${getTextPrimaryColor(baseOverrides)};
    background: transparent;
    pointer-events: none;
  }
  .flatpickr-weekdays {
    background: transparent;
    text-align: center;
    overflow: hidden;
    width: 100%;
    display: flex;
    align-items: center;
    height: 28px;
  }
  .flatpickr-weekdays .flatpickr-weekdaycontainer {
    display: flex;
    flex: 1;
  }
  span.flatpickr-weekday {
    cursor: default;
    font-size: 90%;
    background: transparent;
    color: rgba(0, 0, 0, 0.54);
    line-height: 1;
    margin: 0;
    text-align: center;
    display: block;
    flex: 1;
    font-weight: bolder;
  }
  .dayContainer,
  .flatpickr-weeks {
    padding: 1px 0 0 0;
  }
  .flatpickr-days {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: flex-start;
    width: 307.875px;
  }
  .flatpickr-days:focus {
    outline: 0;
  }
  .flatpickr-day.inRange,
  .flatpickr-day.prevMonthDay.inRange,
  .flatpickr-day.nextMonthDay.inRange,
  .flatpickr-day.today.inRange,
  .flatpickr-day.prevMonthDay.today.inRange,
  .flatpickr-day.nextMonthDay.today.inRange,
  .flatpickr-day:hover,
  .flatpickr-day.prevMonthDay:hover,
  .flatpickr-day.nextMonthDay:hover,
  .flatpickr-day:focus,
  .flatpickr-day.prevMonthDay:focus,
  .flatpickr-day.nextMonthDay:focus {
    cursor: pointer;
    outline: 0;
    background: ${getBorderColor(baseOverrides)};
    border-color: ${getBorderColor(baseOverrides)};
  }
  .flatpickr-day.today {
    border-color: #959ea9;
  }
  .flatpickr-day.today:hover,
  .flatpickr-day.today:focus {
    border-color: #959ea9;
    background: #959ea9;
    color: #fff;
  }
  .flatpickr-day.selected.startRange,
  .flatpickr-day.startRange.startRange,
  .flatpickr-day.endRange.startRange {
    border-radius: 50px 0 0 50px;
  }
  .flatpickr-day.selected.endRange,
  .flatpickr-day.startRange.endRange,
  .flatpickr-day.endRange.endRange {
    border-radius: 0 50px 50px 0;
  }
  .flatpickr-day.selected.startRange.endRange,
  .flatpickr-day.startRange.startRange.endRange,
  .flatpickr-day.endRange.startRange.endRange {
    border-radius: 50px;
  }
  .flatpickr-day.inRange {
    border-radius: 0;
    box-shadow: -5px 0 0 ${getBorderColor(baseOverrides)}, 5px 0 0 ${getBorderColor(baseOverrides)};
  }
  .flatpickr-day.disabled,
  .flatpickr-day.disabled:hover,
  .flatpickr-day.prevMonthDay,
  .flatpickr-day.nextMonthDay,
  .flatpickr-day.notAllowed,
  .flatpickr-day.notAllowed.prevMonthDay,
  .flatpickr-day.notAllowed.nextMonthDay {
    color: rgba(57, 57, 57, 0.3);
    background: transparent;
    border-color: transparent;
    cursor: default;
  }
  .flatpickr-day.disabled,
  .flatpickr-day.disabled:hover {
    cursor: not-allowed;
    color: rgba(57, 57, 57, 0.1);
  }
  .flatpickr-day.week.selected {
    border-radius: 0;
    box-shadow: -5px 0 0 #569ff7, 5px 0 0 #569ff7;
  }
  .flatpickr-day.hidden {
    visibility: hidden;
  }
  .rangeMode .flatpickr-day {
    margin-top: 1px;
  }
  .flatpickr-weekwrapper {
    display: inline-block;
  }
  .flatpickr-weekwrapper .flatpickr-weeks {
    padding: 0 12px;
    box-shadow: 1px 0 0 ${getBorderColor(baseOverrides)};
  }
  .flatpickr-weekwrapper .flatpickr-weekday {
    float: none;
    width: 100%;
    line-height: 28px;
  }
  .flatpickr-weekwrapper span.flatpickr-day,
  .flatpickr-weekwrapper span.flatpickr-day:hover {
    display: block;
    width: 100%;
    max-width: none;
    color: rgba(57, 57, 57, 0.3);
    background: transparent;
    cursor: default;
    border: none;
  }
  .flatpickr-rContainer {
    display: inline-block;
    padding: 0;
    box-sizing: border-box;
  }
  @keyframes fpFadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -20px, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .flatpickr-form-input {
    background-color: var(--white);
    color: var(--text-primary);
    display: block;
    font: var(--font-primary);
    height: 50px;
    line-height: 1.42857143;
    padding-block: 6px;
    padding-inline: 15px;
    width: 100%;
    border: 0;
    cursor: text;

    &:read-only {
      background: white;
    }

    &:focus-visible {
      outline: 0;
    }
  }

  .flatpickr-time {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flatpickr-hour,
  .flatpickr-minute {
    background: none;

    &:hover {
      background: none;
    }
  }

  .flatpickr-am-pm {
    color: ${getTextSecondaryColor(baseOverrides)};
  }

  .flatpickr-time * {
    cursor: pointer;
    background: none;
  }

  .flatpickr-time .numInputWrapper:hover {
    background: none;
  }

  .flatpickr-time input {
    border-radius: var(--border-radius-md);
    outline: none;
    border: none;
    color: ${getTextSecondaryColor(baseOverrides)};
  }

  .flatpickr-time .arrowUp,
  .flatpickr-time .arrowDown {
    display: none;
  }

  .form-input {
    display: none;
  }

  @media (prefers-reduced-motion: reduce) {

`
